import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
/**
 * Utility to check whether a folder is deleted items folder for any mailbox
 * @param folderId - the folderId.Id property of the folder
 */
export default function isDeletedItemsFolderFromAnyMailbox(folderId) {
    return (folderId &&
        (doesFolderIdEqualName(folderId, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID) ||
            doesFolderIdEqualName(folderId, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID)));
}
//# sourceMappingURL=isDeletedItemsFolderFromAnyMailbox.js.map